import React from 'react';
import styles from './Testimonials.module.css';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Analytica X transformed our decision-making process. Their insights helped us increase revenue by 35% in just six months. The team's expertise and dedication are unmatched.",
      author: {
        initials: 'JD',
        name: 'Jennifer Davis',
        role: 'CEO, TechStart Solutions'
      }
    },
    {
      quote: "The predictive models developed by Analytica X have revolutionized our inventory management. We've reduced costs by 20% while improving customer satisfaction.",
      author: {
        initials: 'RW',
        name: 'Robert Wilson',
        role: 'Operations Director, RetailMax'
      }
    },
    {
      quote: "Working with Analytica X was a game-changer. Their data engineering solutions helped us scale our analytics from handling thousands to millions of transactions seamlessly.",
      author: {
        initials: 'LT',
        name: 'Lisa Thompson',
        role: 'CTO, FinanceFlow'
      }
    }
  ];

  return (
    <section id="testimonials" className={`${styles.testimonials} section`}>
      <div className="container">
        <h2 className="section-title fade-in" style={{ color: 'white' }}>Testimonials</h2>
        <div className={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={`${styles.testimonialCard} fade-in`}>
              <p className={styles.testimonialQuote}>{testimonial.quote}</p>
              <div className={styles.testimonialAuthor}>
                <div className={styles.testimonialAvatar}>
                  {testimonial.author.initials}
                </div>
                <div className={styles.testimonialInfo}>
                  <h4>{testimonial.author.name}</h4>
                  <p>{testimonial.author.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
